/* Standalone scroll rig. It does not load GSAP or seek a video.
   One animation frame per scroll/resize; no idle loop or layout-changing motion.
   Custom-element lifecycle supports Shopify section reloads/reordering. */
(() => {
  if (customElements.get('octas-vector-peek')) return;
  class OctasVectorPeek extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.banner = this.closest('.octas-cta');
      this.head = this.querySelector('[data-peek-head]');
      this.leftGrip = this.querySelector('[data-peek-grip="left"]');
      this.rightGrip = this.querySelector('[data-peek-grip="right"]');
      if (!this.banner || !this.head || !this.leftGrip || !this.rightGrip) return;
      this.media = matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = 0;
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      window.addEventListener('scroll', schedule, {passive: true});
      window.addEventListener('resize', schedule, {passive: true});
      window.addEventListener('pageshow', schedule);
      window.addEventListener('load', schedule);
      this.media.addEventListener('change', schedule);
      document.addEventListener('shopify:section:reorder', schedule);
      document.addEventListener('shopify:section:load', schedule);
      this.observer = new ResizeObserver(schedule);
      this.observer.observe(document.querySelector('#MainContent') || document.body);
      this.cleanup = () => {
        cancelAnimationFrame(this.frame);
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        window.removeEventListener('pageshow', schedule);
        window.removeEventListener('load', schedule);
        this.media.removeEventListener('change', schedule);
        document.removeEventListener('shopify:section:reorder', schedule);
        document.removeEventListener('shopify:section:load', schedule);
        this.observer.disconnect();
      };
      this.update();
      document.fonts?.ready.then(() => this.isConnected && schedule());
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
    smooth(value) {
      const x = Math.max(0, Math.min(1, value));
      return x * x * (3 - 2 * x);
    }
    update() {
      const viewport = window.innerHeight || document.documentElement.clientHeight;
      const start = Math.max(.3, Math.min(1, Number(this.dataset.start) / 100 || .95));
      const requestedEnd = Number(this.dataset.end) / 100 || .58;
      const end = Math.max(.05, Math.min(start - .05, requestedEnd));
      const raw = (viewport * start - this.banner.getBoundingClientRect().top) / (viewport * (start - end));
      const progress = this.media.matches ? 1 : Math.max(0, Math.min(1, raw));
      const left = this.smooth(progress / .26);
      const right = this.smooth((progress - .07) / .26);
      const head = this.smooth((progress - .16) / .78);
      const lift = (1 - head) * 148;
      const tilt = this.dataset.tilt === 'true' && !this.media.matches ? -3.5 * Math.sin(head * Math.PI) : 0;
      this.head.setAttribute('transform', `translate(0 ${lift.toFixed(3)}) rotate(${tilt.toFixed(3)} 130 160)`);
      for (const [grip, value] of [[this.leftGrip, left], [this.rightGrip, right]]) {
        grip.setAttribute('transform', `translate(0 ${((1 - value) * 22).toFixed(3)})`);
        grip.setAttribute('opacity', value.toFixed(3));
      }
      this.dataset.progress = progress.toFixed(3);
    }
  }
  customElements.define('octas-vector-peek', OctasVectorPeek);
})();
